import { campaignClickRepository } from '@/repositories/localStorage/campaignClickRepository'
import { groupClickRepository } from '@/repositories/localStorage/groupClickRepository'
import { mediaViewRepository } from '@/repositories/localStorage/mediaViewRepository'
import { ctaClickRepository } from '@/repositories/localStorage/ctaClickRepository'
import { circleOverlayShownRepository } from '@/repositories/localStorage/circleOverlayShownRepository';
import { introAnimationShownRepository } from '@/repositories/localStorage/introAnimationShownRepository';
import { contentSeenRepository } from '@/repositories/localStorage/contentSeenRepository';
import { targetingSegmentRepository } from '@/repositories/localStorage/targetingSegmentRepository';
import { targetingQuestionnaireSkipRepository } from '@/repositories/localStorage/targetingQuestionnaireSkipRepository';

const repositories = {
  campaignClick: campaignClickRepository,
  groupClick: groupClickRepository,
  mediaView: mediaViewRepository,
  ctaClick: ctaClickRepository,
  circleOverlay: circleOverlayShownRepository,
  introAnimation: introAnimationShownRepository,
  contentSeen: contentSeenRepository,
  targetingSegment: targetingSegmentRepository,
  targetingQuestionnaireSkip: targetingQuestionnaireSkipRepository,
}
export const localStorageRepositoryFactory = {
  get: (key) => repositories[key]
}
